<template>
  <div
    v-if="item"
    @click="click"
    class="clickable-div"
  >
    <v-row
      no-gutters
      align="center"
    >
      <div class="d-flex align-center">
        <v-img
          width="80"
          height="80"
          contain
          :src="item.image || '/images/not-found.png'"
        />
      </div>

      <div
        class="text-body-2 ml-4"
        style="color: black"
        v-text="item.name || 'Отсутствует'"
      />
    </v-row>
  </div>
  <div
    v-else
    @click="click"
    align="center"
    class="clickable-div"
  >
    Выбрать модификатор
  </div>
</template>

<script>
  export default {
    name: 'IngredientCell',
    props: {
      item: {
        type: Object,
        required: false
      }
    },
    methods: {
      click() {
        this.$emit('click')
      }
    }
  }
</script>

<style scoped>
  .clickable-div {
    cursor: pointer;
    padding: 12px;
    border: 1.5px solid #cccccc91;
    border-radius: 10px;
    transition: background-color 0.3s;
  }

  .clickable-div:hover {
    background-color: #f5f5f5;
  }
</style>
